import { createApiRequest, ApiResponse } from "@/api"
import { API_URL, Endpoints } from "@/constants/endpoints"
import { HttpMethods } from "@/constants/globals"

export interface LoginResponse {
   token: string
   expiry: string
}

export interface MfaRequiredResponse {
   mfaRequired: true
   challengeId: string
}

export interface EntraLoginResponse {
   authorizeUrl: string
}

export interface VerificationResponse {
   token: string
}

export interface UserActivationResponse {
   confirmPassword: string
}

export interface PasswordRecoveryResponse {
   email: string
}

export interface PasswordRecoveryConfirmResponse {
   email: string
}

export async function requestLogin(
   email: string,
   password: string
): Promise<ApiResponse<LoginResponse | MfaRequiredResponse>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.LOGIN}`,
      HttpMethods.POST,
      {
         email,
         password,
      }
   )
   return response
}

export async function requestLoginVerify(
   challengeId: string,
   code: string
): Promise<ApiResponse<LoginResponse>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.LOGIN_VERIFY}`,
      HttpMethods.POST,
      {
         challengeId,
         code,
      }
   )
   return response
}

export async function requestEntraLogin(): Promise<
   ApiResponse<EntraLoginResponse>
> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.ENTRA_LOGIN}`,
      HttpMethods.GET
   )
   return response
}

export async function requestEntraCallback(
   code: string,
   state: string
): Promise<ApiResponse<LoginResponse>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.ENTRA_CALLBACK}`,
      HttpMethods.POST,
      {
         code,
         state,
      }
   )
   return response
}

export async function requestLogout(): Promise<ApiResponse<void>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.LOGOUT}`,
      HttpMethods.POST
   )
   return response.data
}

export async function requestVerify(
   token: string
): Promise<ApiResponse<VerificationResponse>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.VERIFY}${token}`,
      HttpMethods.GET
   )
   return response.data
}

export async function requestActivateUser(
   token: string,
   password: string,
   confirmPassword: string
): Promise<ApiResponse<UserActivationResponse>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.ACTIVATE_USER}`,
      HttpMethods.POST,
      {
         token,
         password,
         confirmPassword,
      }
   )
   return response
}

export async function requestPasswordRecovery(
   email: string
): Promise<ApiResponse<PasswordRecoveryResponse>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.PASSWORD_RESET}`,
      HttpMethods.POST,
      {
         email,
      }
   )
   return response
}

export async function requestPasswordRecoveryConfirm(
   token: string,
   password: string,
   confirmPassword: string
): Promise<ApiResponse<PasswordRecoveryConfirmResponse>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.PASSWORD_RESET_CONFIRM}`,
      HttpMethods.POST,
      {
         token,
         password,
         confirmPassword,
      }
   )
   return response
}
